import { render } from "./GroupManager.vue?vue&type=template&id=2b27b12c&scoped=true"
import script from "./GroupManager.vue?vue&type=script&lang=js"
export * from "./GroupManager.vue?vue&type=script&lang=js"

import "./GroupManager.vue?vue&type=style&index=0&id=2b27b12c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b27b12c"]])

export default __exports__